import reducer from './reducers';
import * as templatesActions from './actions';
import * as templatesSelectors from './selectors';

export { templatesActions, templatesSelectors };
export default reducer;